import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useSEO } from "./seo";

export default function AuthAction() {
  useSEO({
    title: "You're verified — nailtape™",
    description:
      "Your email is confirmed. Head back to the nailtape™ app to pick up where you left off.",
    path: "/auth_action",
  });

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-bone px-6 py-20 text-center text-ink"
      data-testid="auth-action-page"
    >
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="flex flex-col items-center"
      >
        <p className="font-georgia text-2xl tracking-tight">
          nt.<span className="align-super text-[0.4em] tracking-normal">™</span>
        </p>

        <div
          className="mt-12 flex h-20 w-20 -rotate-6 items-center justify-center rounded-full border-2 border-ink bg-pastel-mint shadow-chunk"
          data-testid="verified-check-sticker"
        >
          <Check strokeWidth={3} className="h-9 w-9" />
        </div>

        <h1 className="mt-10 max-w-2xl font-georgia text-4xl leading-[1.08] tracking-tight md:text-6xl">
          You’ve been{" "}
          <em className="bg-pastel-pink px-2 italic">verified.</em>
        </h1>

        <p className="mt-6 max-w-md text-base leading-relaxed text-ink/70 md:text-lg">
          Your email is confirmed and everything is set. Head back to the app
          to pick up right where you left off.
        </p>

        <a
          href="nailtape://"
          data-testid="back-to-app-button"
          className="mt-10 inline-flex items-center rounded-full border-2 border-ink bg-pastel-pink px-10 py-4 font-display text-sm font-extrabold uppercase tracking-tight shadow-chunk transition-all duration-200 hover:-translate-y-0.5 hover:shadow-chunk-lg"
        >
          Head back to the app
        </a>

        <p className="mt-5 text-sm text-stone-500">
          Open this page on the device that has the nailtape™ app.
        </p>
      </motion.div>

      <p className="mt-16 font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-stone-400">
        nailtape™ — the standard for the modern press-on business
      </p>
    </div>
  );
}
